import {
  FETCH_WALLET_REQUEST,
  FETCH_WALLET_SUCCESS,
  FETCH_WALLET_FAILURE,
  SAVE_LOGGED_USER,
  CLEAR_LOGGED_USER,
  SET_SELECTED_APPOINTMENT,
  CLEAR_SELECTED_APPOINTMENT,
} from "../actions/UserActions";

const initialState = {
  walletDetails: {},
  walletAmount: 0,
  isLoading: false,
  error: null,
  loggedUser: null,
  selectedAppt: null
};

export const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_WALLET_REQUEST:
      return { ...state, isLoading: true };

    case FETCH_WALLET_SUCCESS:
      return {
        ...state,
        walletDetails: action.payload,
        walletAmount: action.payload.amount,
        isLoading: false,
      };

    case FETCH_WALLET_FAILURE:
      return { ...state, error: action.payload, isLoading: false };

    case SAVE_LOGGED_USER:
      return { ...state, loggedUser: action.payload };

    case CLEAR_LOGGED_USER:
      return { ...state, loggedUser: action.payload };

    case SET_SELECTED_APPOINTMENT:
      return { ...state, selectedAppt: action.payload };

    case CLEAR_SELECTED_APPOINTMENT:
      return { ...state, selectedAppt: action.payload };

    default:
      return state;
  }
};
